var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgrammed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1821_8822)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5.875,
    r: 5,
    fill: "#64DD17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57532 5.63922L3.37915 6.90718L3.37915 4.37126L5.57532 5.63922Z",
    fill: "#64DD17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89355 2.24353L3.89357 3.09637C3.89363 5.45444 5.47647 7.5189 7.7537 8.13103L8.2287 6.38103L5.70632 5.69353L5.70632 2.24353L3.89355 2.24353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5.875,
    r: 5,
    fill: "#64DD17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57532 5.63922L3.37915 6.90718L3.37915 4.37126L5.57532 5.63922Z",
    fill: "#64DD17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.45121 2.22253H4.64478V6.28752L8.18749 8.36877L8.59999 7.69377L5.45121 5.8219V2.22253Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1821_8822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.875)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammed);
export default __webpack_public_path__ + "static/media/programmed.8133e99b84340e919098883c27712828.svg";
export { ForwardRef as ReactComponent };